import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { getPartByID } from '@reducers/parts';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { OperationSearchItem } from '@interfaces/search';
import { SingleJobOrList } from '@v2/pages/machines/modules/now/components/Job/components/SingleJobOrList';

interface PartDetailsJobsProps {
  jobs: ReducerEntityWithLoadingState<OperationSearchItem[]>;
  jobId: number | null;
}

const PartDetailsJobsComponent: FC<PartDetailsJobsProps> = ({
  clearTools,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  jobs,
  jobId,
}) => {
  const title = useTitle();

  const { jobDataLoading } = usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch,
    getAllJobs: true,
  });

  return (
    <DetailsPageWrapper title={title.job}>
        <SingleJobOrList jobs={jobs.data} jobId={jobId} loading={!jobs.wasLoaded} jobDataLoadingForList={jobDataLoading} />
    </DetailsPageWrapper>
  );
};

const PartDetailsJobs = connect(({ details: { jobs, jobId } }) => ({ jobs, jobId }), {
  clearTools,
  getNCFileByPartId,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  operationsSearch,
})(PartDetailsJobsComponent);

export { PartDetailsJobs };
